<template>
	<div class="formlist">
		<slot></slot>
	</div>
</template>
<script>
	export default {
		name: 'formlist'
	}
</script>


// WEBPACK FOOTER //
// src/components/formlist/formlist.vue